var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"market-data-page"},[_c(_setup.ContextFiles,{attrs:{"files":_setup.files,"uploading-files":_setup.uploadingFiles,"max-files":_setup.MAX_FILES,"can-edit":_setup.canEdit,"disabled":_setup.isBusy,"accept":_setup.MARKET_DATA_ACCEPT},on:{"upload":_setup.onUpload,"remove":_setup.onRemove}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }